"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorName = exports.colorDeserialize = exports.colorAll = void 0;
const stringEnumDeserialize_1 = __importDefault(require("./stringEnumDeserialize"));
const tupleForUnionType_1 = require("./tupleForUnionType");
exports.colorAll = (0, tupleForUnionType_1.tupleForUnionType)({
    '#FF0900': undefined,
    '#FF7F00': undefined,
    '#FFEF00': undefined,
    '#00F11D': undefined,
    '#0079FF': undefined,
    '#A800FF': undefined,
    '#000000': undefined,
    '#FFFFFF': undefined,
});
exports.colorDeserialize = (0, stringEnumDeserialize_1.default)(exports.colorAll, 'color', false);
function colorName(color) {
    switch (color) {
        case '#FF0900':
            return 'red';
        case '#FF7F00':
            return 'orange';
        case '#FFEF00':
            return 'yellow';
        case '#00F11D':
            return 'green';
        case '#0079FF':
            return 'blue';
        case '#A800FF':
            return 'purple';
        case '#000000':
            return 'black';
        case '#FFFFFF':
            return 'white';
        default:
            throw new Error('Unkown Color');
    }
}
exports.colorName = colorName;
